import { cloneDeep } from 'lodash-es'

export function reorderVisibleQuestions(
  allQuestions = [],
  visibleQuestions = [],
  isQuestionTypeSupported
) {
  if (typeof isQuestionTypeSupported !== 'function') {
    throw new TypeError('isQuestionTypeSupported must be a function')
  }

  const reorderedQuestions = visibleQuestions.map(question =>
    cloneDeep(question)
  )
  const visibleQuestionsCount = allQuestions.filter(question =>
    isQuestionTypeSupported(question?.type)
  ).length

  if (visibleQuestionsCount !== reorderedQuestions.length) {
    return allQuestions
  }

  let visibleIndex = 0

  return allQuestions.map(question => {
    if (!isQuestionTypeSupported(question?.type)) {
      return question
    }

    const nextQuestion = reorderedQuestions[visibleIndex]
    visibleIndex += 1

    return nextQuestion || cloneDeep(question)
  })
}
